import React, { Component } from "react";

import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel
} from "react-bootstrap";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import InputMask from 'react-input-mask';

import header_mobile from "../../assets/img/header-mobile.jpg";
import header_desktop from "../../assets/img/header-desktop.jpg";



const restLink_account = new HttpLink({ credentials: 'include', uri: "/api/v1/account/" });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

 const LOGIN = gql`
     query login($cpf: String!, $password: String!, $external_id: String!){
       login(cpf:$cpf, password:$password, external_id:$external_id){
         id
         token
         error_login_msg
       }
     }
   `;


const LOGIN_INSERT = gql`
  query login_insert_cpf($cpf: String!, $password: String!,$repassword: String!, $external_id: String!){
    login_insert_cpf(cpf:$cpf, external_id:$external_id, password:$password, repassword:$repassword, is_admin: 1, is_matricula:1){
      id
      token
      error_login_msg
    }
  }
`;

const LOGIN_GOOGLE = gql`
  query login_google($code: String!){
    login_google(code:$code){
      id
      token
    }
  }
`;

const VALID_CPF = gql`
  query valid_cpf($cpf: String!){
    valid_cpf(cpf:$cpf, is_matricula:1){
      is_valid
      is_error
      msg_error
    }
  }
`;

class Login extends Component {
  
  state = {
    valid_cpf: false,
    step: 1,

    cpf: "",
    email: null,
    password: null,
    repassword: null,
    code: null,
    msg: null,
    msg_type: "info"
  }



  login_insert = async () => {

    if(!this.state.code || !this.state.cpf ||  !this.state.password ||  !this.state.repassword ) {
      this.setState({
        msg_type: "warning",
        msg: "Preencha todos os campos"
      });
    }
    else {
      const user = (await account_client.query({
        variables: {
          cpf: this.state.cpf,
          password: this.state.password,
          repassword: this.state.repassword,
          external_id: this.state.code
        },
        query: LOGIN_INSERT,
        fetchPolicy: 'no-cache'
      })).data.login_insert_cpf;
      if(user.token !== null) {
        document.cookie = "token_user="+user.token;// Grava o coookie
        this.setState({
          msg_type: "info",
          msg: "Login feito com sucesso, aguarde, você será redirecionado."
        });
        window.location.replace('/');
      } else {
        this.setState({
          msg_type: "warning",
          msg: user.error_login_msg
        });
      }
    }

    
  }




  login = async () => {

    if(!this.state.code || !this.state.cpf ||  !this.state.password ) {
      this.setState({
        msg_type: "warning",
        msg: "Preencha todos os campos"
      });
    }
    else {
      const user = (await account_client.query({
        variables: { 
          external_id: this.state.code,
          cpf: this.state.cpf, 
          password: this.state.password 
        },
        query: LOGIN,
        fetchPolicy: 'no-cache'
      })).data.login;
      if (user.token !== null) {
        document.cookie = "token_user=" + user.token;// Grava o coookie
        this.setState({
          msg_type: "info",
          msg: "Login feito com sucesso, aguarde, você será redirecionado."
        });
        window.location.replace('/');
      } else {
        this.setState({
          msg_type: "warning",
          msg: user.error_login_msg
        });
      }    }

    
  }


  //onChange_email = email => this.setState({ email })

  onChange_email = (event) => {
    this.setState({email: event.target.value});
  }
  onChange_password = (event) => {
      this.setState({password: event.target.value});
  }
  onChange_repassword = (event) => {
      this.setState({repassword: event.target.value});
  }

  onChange_cpf = (event) => {
    this.setState({cpf: event.target.value});
  }

  onChange_code = (event) => {
    this.setState({code: event.target.value});
  }
  

  validCpf = async () => {


    const valid_cpf = (await account_client.query({
    variables: {cpf: this.state.cpf},
    query: VALID_CPF,
    fetchPolicy: 'no-cache'
    })).data.valid_cpf;

    if(valid_cpf.is_error) {
      this.setState({
        msg_type: "warning",
          msg: valid_cpf.msg_error
      });
    }
    else {
      this.setState({
        valid_cpf : valid_cpf.is_valid === 1,
        step: 2,
        msg: ""
      });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if(this.state.valid_cpf) {
      this.login();
    }
    else {
      this.login_insert();
    }

  }

  render() {

    return (

      <div>
        <img className="header_desktop" src={header_desktop} />
        <img className="header_mobile" src={header_mobile} />

        <div className="container">
        <h1 className="title">Faça seu cadastro administrador para ter acesso aos relatórios</h1>
        </div>
      <div className="login-box">

              <form
              onSubmit={e => {
                this.handleSubmit(e);
                e.preventDefault();
              }}
              >

              <FormGroup>
              <FormInputs
                  ncols={["col-md-12"]}
                  proprieties={[
                    {
                      onChange:this.onChange_code,
                      name: "code",
                      label: "Código da empresa",
                      type: "text",
                      bsClass: "form-control",
                      placeholder: "Código da empresa",
                      defaultValue: ""
                    }
                  ]}
                />

                <ControlLabel>Matrícula</ControlLabel>
                <div>
                <InputMask 
                  className="form-control"
                  name="cpf"
                  mask="999999" 
                  value={this.state.cpf}
                  onChange={this.onChange_cpf} 
                />
                </div>
              </FormGroup>
              {
                    this.state.step === 1 && <div>
                      <Row>
                        <Col md={3}>
                            <Button bsStyle="info" fill onClick={this.validCpf}>
                              CONTINUAR
                            </Button>
                        </Col>
                      </Row>
                    </div>
              }

              {
              this.state.step === 2 && this.state.valid_cpf && <div>
                <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_password,
                        name: "password",
                        label: "Senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Senha",
                        defaultValue: ""
                      }
                    ]}
                  /> 
                   <Row>
                    <Col md={3}>
                        <Button bsStyle="info" fill type="submit">
                          ENTRAR
                        </Button>
                    </Col>

                  </Row>
                  <a href="/#register-pass/">Esqueceu a senha?</a>

              </div>
            }

              {
              this.state.step === 2 && !this.state.valid_cpf && <div>

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_password,
                        name: "password",
                        label: "Senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Senha",
                        defaultValue: ""
                      }
                    ]}
                  /> 

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_repassword,
                        name: "password",
                        label: "Repetir senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Repetir senha",
                        defaultValue: ""
                      }
                    ]}
                  /> 

                  <Row>
                    <Col md={3}>
                        <Button bsStyle="info" fill type="submit">
                          ENTRAR
                        </Button>
                    </Col>
                  </Row>
                  </div>
                }

                  <Row>
                    {
                      this.state.msg &&
                      <Col md={10}>
                        <Alert bsStyle={this.state.msg_type}>
                          {this.state.msg}
                        </Alert>
                      </Col>
                    }
                    
                  </Row>

             </form>
      </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Auth/RegisterAdminCustom.jsx